<template lang="pug">
  .component-selectize-plan

    loading-spinner(v-if="loading")
    select(v-model="selected", v-else, @change="$emit('input', $event.target.value)")
      option(:value="null") Select city
      option(v-for="option in options", :value="option.id") C{{option.id}} {{option.name}}
</template>

<script>
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import LoadingSpinner from '../../../LoadingSpinner'

export default {
  name: 'SelectizeCity',

  components: {LoadingSpinner},
  data() {
    return {
      loading: true,
      selected: this.value,
    }
  },
  created() {
    KeplerBackofficeSdk.cities.list().all(1, -1, (data) => {
      this.options = data.items
      this.loading = false
    })
  },
  props: {
    value: {default: null}
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeCity.vue?c0fb4746